import Swiper, { Autoplay, Navigation, Pagination, Scrollbar, Thumbs, } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Thumbs]);

export default function CardsSlider() {
  const options = {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    draggable: true,
    preloadImages: false,
    rewind: true,
    scrollbar: {
      el: '.cards-slider .swiper-scrollbar',
      hide: false,
      draggable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.cards-slider .swiper-button-next',
      prevEl: '.cards-slider .swiper-button-prev',
      // disabledClass: 'hide-display',
      lockClass: 'hide-display',
    },
    slidesOffsetAfter: 200,
    on: {
      beforeInit: changeSliderInitOffset,
      beforeResize: changeSliderInitOffset,
    },
    breakpoints: {
      1440: {
        autoHeight: false,
      },
      0: {
        autoHeight: true,
      },
    },
  };

  // eslint-disable-next-line no-unused-vars
  const cardsSwiper = new Swiper('.cards-slider .swiper', options);

  const tabsBtn = document.querySelectorAll('.slider-block .tabs-container .tab');
  const tabsBtnLetter = document.querySelectorAll('.handbook-content .tabs-container .tab');

  function cardsSlider(tabBtn) {
    if (tabBtn) {
      tabBtn.forEach((tab) => {
        tab.addEventListener('click', function () {
          const slider = document.querySelector(`#${this.dataset.tab}`);
          if (!slider) {
            return;
          }
          const parentSection = this.closest('section');
          const showSlider = parentSection.querySelector('.show-slider');
          if (showSlider) {
            showSlider.classList.remove('show-slider');
          }
          parentSection.querySelector('.tab-active').classList.remove('tab-active');
          this.classList.add('tab-active');
          slider.classList.add('show-slider');
        });
      });
    }
  }

  cardsSlider(tabsBtn);
  cardsSlider(tabsBtnLetter);
}

/**
 * Изменить левое стартовое смещение слайда, относительно элемента в page-container.
 * @param {Swiper} sw
 */
function changeSliderInitOffset(sw) {
  sw.params.slidesOffsetBefore = findOffset(sw.el, sw);
  sw.params.slidesOffsetAfter = findOffset(sw.el, sw);
  sw.update();
}

/**
 * Получить смещение для блока с табами от левого края экрана.
 * @param {Element} element
 */
function findOffset(element, sw) {
  const el = element.closest('*[data-offset]');
  if (el) {
    const tab = el.querySelector('*[data-offset-anchor]');
    const offset = tab.offsetLeft;
    if (window.screen.width <= 1440) {
      return 0;
    }
    return offset;
  }

  return 0;
}
